<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <div class="modal-card">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">{{ action }} Scope</h1>
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column">
            <b-field label="Country">
              <b-select
                expanded
                name="country"
                v-model="form.country"
                v-on:input="filterScheme"
                placeholder="Please select"
                :disabled="viewOnly"
              >
                <option
                  v-for="(option, index) in countries"
                  :value="option.id"
                  :key="index"
                  selected
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
            <b-field label="Scheme">
              <b-select
                expanded
                name="scheme"
                v-model="form.scheme"
                v-on:input="filterStream"
                :disabled="viewOnly"
                placeholder="Please select"
              >
                <option
                  v-for="(option, index) in schemes"
                  :value="option.id"
                  :key="index"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
            <b-field label="Stream">
              <b-select
                expanded
                name="stream"
                v-model="form.stream"
                placeholder="Please select"
                :disabled="viewOnly"
                v-on:input="putStreamValue"
              >
                <option
                  v-for="(option, index) in containers"
                  :value="option.id"
                  :key="index"
                >
                  {{ option.name }}
                </option>
              </b-select>
            </b-field>
            <b-field label="Valid From">
              <b-datepicker
                class="analytics-date-picker"
                name="valid_from"
                v-model="form.valid_from"
                required
                icon="calendar-today"
                trap-focus
                v-on:input="checkValues"
                :date-formatter="dateFormatter"
              >
              </b-datepicker>
            </b-field>
            <b-field label="Valid To">
              <b-datepicker
                class="analytics-date-picker"
                name="valid_to"
                v-model="form.valid_to"
                required
                icon="calendar-today"
                trap-focus
                v-on:input="checkValues"
                :date-formatter="dateFormatter"
              >
              </b-datepicker>
            </b-field>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot" v-if="!viewOnly">
        <b-button slot="right" type="is-normal" @click="cancel">
          Cancel
        </b-button>
        <b-button
          slot="right"
          native-type="submit"
          type="is-primary"
          v-on:click="validateBeforeSubmit"
          :disabled="disableOKButton"
        >
          <b-tooltip
            v-if="disableOKButton"
            :label="tooltipMsg"
            position="is-right"
            multilined
          >
            OK
          </b-tooltip>
          <span v-else>OK</span>
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import UtilityMixin from "@/mixins/UtilityMixin";
import scopeMixin from "@/mixins/scopeMixin";
import RulesManagerService from "../../services/RulesManagerService";
// @group Dashboard
export default {
  name: "AddScope",
  mixins: [UtilityMixin, scopeMixin],
  props: {
    action: {
      type: String,
      default: "Inserts"
    },
    viewOnly: {
      type: Boolean,
      default: true
    },
    isActive: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: () => {
        return {
          id: "",
          country: "",
          scheme: "",
          stream: "",
          valid_from: "",
          valid_to: ""
        };
      }
    },
    accountId: {
      type: Number,
      default: -1
    },
    isDelete: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      isModalActive: false,
      loading: "",
      disableOKButton: false,
      tooltipMsg: "Country is mandatory. Please select country first",
      RulesManagerService: new RulesManagerService()
    };
  },
  mounted() {
    this.fetchCountries();
    this.fetchSchemes();
    this.fetchContainers();
    this.checkValues();
  },
  methods: {
    dateFormatter(dt) {
      if (dt != null) {
        return dt.toLocaleDateString("fr-CA");
      }
      return dt;
    },
    filterScheme(countryId) {
      this.country = this.countries.filter(e => e.id == countryId);
      this.form.country_code = this.country ? this.country[0].code : "";
      this.form.country_name = this.country ? this.country[0].name : "";
      if (countryId) {
        this.schemeDataService.getByCountry(countryId).subscribe(
          response => {
            this.schemes = response;
          },
          e => {
            console.log(e);
          }
        );
      }
      this.checkValues();
    },
    filterStream(schemeId) {
      this.scheme = this.schemes.filter(e => e.id == schemeId);
      this.form.scheme_name = this.scheme ? this.scheme[0].name : "";
      if (schemeId) {
        this.schemeDataService.get(schemeId).subscribe(
          response => {
            this.containers = response["container"];
            this.containers = this.containers.filter(e => e.name !== "General");
          },
          e => {
            console.log(e);
          }
        );
      }
    },
    putStreamValue(streamId) {
      this.stream = this.containers.filter(e => e.id == streamId);
      this.form.stream_name = this.stream ? this.stream[0].name : "";
    },
    cancel() {
      this.disableOKButton = true;
      this.$emit("cancel");
    },
    validateBeforeSubmit() {
      this.RulesManagerService.checkForDuplicateScope(this.form).subscribe(
        response => {
          if (response.status) {
            this.$buefy.dialog.alert({
              title: "Error",
              message: "This scope was already created",
              type: "is-danger",
              ariaRole: "alertdialog",
              ariaModal: true
            });
          } else {
            this.submit();
          }
        }
      );
    },
    submit() {
      this.$emit("confirm", this.form);
    },
    checkValues() {
      if (this.form.country && this.form.valid_to && this.form.valid_from) {
        this.disableOKButton = false;
      } else {
        this.disableOKButton = true;
      }
    }
  },
  watch: {
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    }
  }
};
</script>
